// US Payroll Reference Data
// Tax tables, compliance data, and configuration constants

// ============================================================================
// Federal Withholding Tables (2024 Publication 15-T)
// ============================================================================

export const FEDERAL_WITHHOLDING_TABLES = {
  // Percentage Method Tables for Manual Payroll Systems
  // These are the amounts to subtract based on pay period
  standardDeductionPerPayPeriod: {
    single: {
      weekly: 281.54,
      biweekly: 563.08,
      semimonthly: 610.00,
      monthly: 1220.00
    },
    married: {
      weekly: 563.08,
      biweekly: 1126.15,
      semimonthly: 1220.00,
      monthly: 2440.00
    }
  }
};

// ============================================================================
// State Unemployment Insurance (SUI) Rates by State
// ============================================================================

export const SUI_RATES = {
  AL: { minRate: 0.0065, maxRate: 0.068, newEmployerRate: 0.027, wageBase: 8000 },
  AK: { minRate: 0.01, maxRate: 0.054, newEmployerRate: 0.021, wageBase: 47100 },
  AZ: { minRate: 0.0008, maxRate: 0.207, newEmployerRate: 0.02, wageBase: 8000 },
  AR: { minRate: 0.001, maxRate: 0.14, newEmployerRate: 0.032, wageBase: 7000 },
  CA: { minRate: 0.015, maxRate: 0.062, newEmployerRate: 0.034, wageBase: 7000 },
  CO: { minRate: 0.0071, maxRate: 0.117, newEmployerRate: 0.0171, wageBase: 20400 },
  CT: { minRate: 0.01, maxRate: 0.065, newEmployerRate: 0.031, wageBase: 15000 },
  DE: { minRate: 0.001, maxRate: 0.08, newEmployerRate: 0.012, wageBase: 10500 },
  DC: { minRate: 0.016, maxRate: 0.07, newEmployerRate: 0.027, wageBase: 9000 },
  FL: { minRate: 0.001, maxRate: 0.054, newEmployerRate: 0.027, wageBase: 7000 },
  GA: { minRate: 0.0004, maxRate: 0.086, newEmployerRate: 0.027, wageBase: 9500 },
  HI: { minRate: 0.0, maxRate: 0.056, newEmployerRate: 0.03, wageBase: 56700 },
  ID: { minRate: 0.0021, maxRate: 0.0516, newEmployerRate: 0.01, wageBase: 49900 },
  IL: { minRate: 0.0025, maxRate: 0.077, newEmployerRate: 0.0325, wageBase: 13590 },
  IN: { minRate: 0.005, maxRate: 0.075, newEmployerRate: 0.025, wageBase: 9500 },
  IA: { minRate: 0.0, maxRate: 0.07, newEmployerRate: 0.01, wageBase: 36100 },
  KS: { minRate: 0.001, maxRate: 0.075, newEmployerRate: 0.027, wageBase: 14000 },
  KY: { minRate: 0.003, maxRate: 0.09, newEmployerRate: 0.027, wageBase: 11400 },
  LA: { minRate: 0.0009, maxRate: 0.062, newEmployerRate: 0.0128, wageBase: 7700 },
  ME: { minRate: 0.0013, maxRate: 0.054, newEmployerRate: 0.0254, wageBase: 12000 },
  MD: { minRate: 0.003, maxRate: 0.075, newEmployerRate: 0.026, wageBase: 8500 },
  MA: { minRate: 0.0056, maxRate: 0.182, newEmployerRate: 0.0294, wageBase: 15000 },
  MI: { minRate: 0.0006, maxRate: 0.1078, newEmployerRate: 0.027, wageBase: 9500 },
  MN: { minRate: 0.001, maxRate: 0.09, newEmployerRate: 0.01, wageBase: 40000 },
  MS: { minRate: 0.0, maxRate: 0.054, newEmployerRate: 0.012, wageBase: 14000 },
  MO: { minRate: 0.0, maxRate: 0.06, newEmployerRate: 0.0251, wageBase: 10500 },
  MT: { minRate: 0.0013, maxRate: 0.0613, newEmployerRate: 0.0172, wageBase: 40500 },
  NE: { minRate: 0.0, maxRate: 0.055, newEmployerRate: 0.0125, wageBase: 9000 },
  NV: { minRate: 0.0025, maxRate: 0.054, newEmployerRate: 0.0275, wageBase: 40100 },
  NH: { minRate: 0.001, maxRate: 0.07, newEmployerRate: 0.025, wageBase: 14000 },
  NJ: { minRate: 0.005, maxRate: 0.069, newEmployerRate: 0.0275, wageBase: 42300 },
  NM: { minRate: 0.0033, maxRate: 0.054, newEmployerRate: 0.01, wageBase: 30100 },
  NY: { minRate: 0.013, maxRate: 0.099, newEmployerRate: 0.041, wageBase: 12500 },
  NC: { minRate: 0.0006, maxRate: 0.056, newEmployerRate: 0.01, wageBase: 29600 },
  ND: { minRate: 0.0008, maxRate: 0.0955, newEmployerRate: 0.0106, wageBase: 43800 },
  OH: { minRate: 0.003, maxRate: 0.09, newEmployerRate: 0.027, wageBase: 9000 },
  OK: { minRate: 0.001, maxRate: 0.055, newEmployerRate: 0.017, wageBase: 27000 },
  OR: { minRate: 0.007, maxRate: 0.054, newEmployerRate: 0.021, wageBase: 52800 },
  PA: { minRate: 0.0169, maxRate: 0.1067, newEmployerRate: 0.0369, wageBase: 10000 },
  RI: { minRate: 0.0099, maxRate: 0.095, newEmployerRate: 0.0121, wageBase: 29200 },
  SC: { minRate: 0.0006, maxRate: 0.054, newEmployerRate: 0.0054, wageBase: 14000 },
  SD: { minRate: 0.0, maxRate: 0.095, newEmployerRate: 0.012, wageBase: 15000 },
  TN: { minRate: 0.001, maxRate: 0.10, newEmployerRate: 0.026, wageBase: 7000 },
  TX: { minRate: 0.0031, maxRate: 0.062, newEmployerRate: 0.027, wageBase: 9000 },
  UT: { minRate: 0.001, maxRate: 0.072, newEmployerRate: 0.011, wageBase: 44800 },
  VT: { minRate: 0.008, maxRate: 0.055, newEmployerRate: 0.01, wageBase: 14100 },
  VA: { minRate: 0.0015, maxRate: 0.065, newEmployerRate: 0.0253, wageBase: 8000 },
  WA: { minRate: 0.0027, maxRate: 0.0602, newEmployerRate: 0.0147, wageBase: 67600 },
  WV: { minRate: 0.015, maxRate: 0.085, newEmployerRate: 0.027, wageBase: 9000 },
  WI: { minRate: 0.0, maxRate: 0.12, newEmployerRate: 0.0335, wageBase: 14000 },
  WY: { minRate: 0.0009, maxRate: 0.086, newEmployerRate: 0.0178, wageBase: 30900 }
};

// ============================================================================
// State Disability Insurance (SDI) Data
// ============================================================================

export const SDI_DATA = {
  CA: { 
    rate: 0.009, 
    wageBase: 153164,
    name: 'California State Disability Insurance',
    employeeOnly: true
  },
  HI: { 
    rate: 0.005, 
    wageBase: 61700,
    name: 'Hawaii Temporary Disability Insurance',
    employeeOnly: false
  },
  NJ: { 
    rate: 0.0014, 
    wageBase: 161400,
    name: 'New Jersey Temporary Disability Insurance',
    employeeOnly: true
  },
  NY: { 
    rate: 0.005, 
    wageBase: 13000, // Max weekly benefit based
    name: 'New York Disability Benefits',
    employeeOnly: true
  },
  RI: { 
    rate: 0.012, 
    wageBase: 87300,
    name: 'Rhode Island Temporary Disability Insurance',
    employeeOnly: true
  },
  PR: { 
    rate: 0.003, 
    wageBase: 9000,
    name: 'Puerto Rico Disability Insurance',
    employeeOnly: false
  }
};

// ============================================================================
// Paid Family Medical Leave (PFML) Data
// ============================================================================

export const PFML_DATA = {
  CA: { 
    rate: 0.009, // Combined with SDI
    wageBase: 153164,
    name: 'California Paid Family Leave',
    employeeOnly: true
  },
  CO: { 
    employeeRate: 0.0045,
    employerRate: 0.0045,
    wageBase: 167700,
    name: 'Colorado Family and Medical Leave Insurance'
  },
  CT: { 
    employeeRate: 0.005,
    employerRate: 0,
    wageBase: 168600,
    name: 'Connecticut Paid Leave'
  },
  DC: { 
    employeeRate: 0,
    employerRate: 0.0026,
    wageBase: null, // No cap
    name: 'DC Paid Family Leave'
  },
  DE: {
    employeeRate: 0.005,
    employerRate: 0.005,
    wageBase: 168600,
    name: 'Delaware Paid Family and Medical Leave',
    startDate: '2026-01-01'
  },
  MA: { 
    employeeRate: 0.00318,
    employerRate: 0.00612,
    wageBase: 168600,
    name: 'Massachusetts Paid Family and Medical Leave'
  },
  MD: {
    employeeRate: 0.0045,
    employerRate: 0.0045,
    wageBase: 168600,
    name: 'Maryland Family and Medical Leave Insurance',
    startDate: '2025-07-01'
  },
  MN: {
    employeeRate: 0.004,
    employerRate: 0.004,
    wageBase: 168600,
    name: 'Minnesota Paid Leave',
    startDate: '2026-01-01'
  },
  NJ: { 
    employeeRate: 0.0014, // Separate from TDI
    employerRate: 0,
    wageBase: 161400,
    name: 'New Jersey Family Leave Insurance'
  },
  NY: { 
    employeeRate: 0.00455,
    employerRate: 0,
    wageBase: 87785, // State average weekly wage x 52
    name: 'New York Paid Family Leave'
  },
  OR: { 
    employeeRate: 0.006,
    employerRate: 0.004,
    wageBase: 168600,
    name: 'Oregon Paid Leave'
  },
  RI: { 
    employeeRate: 0.012, // Combined with TDI
    employerRate: 0,
    wageBase: 87300,
    name: 'Rhode Island Temporary Caregiver Insurance'
  },
  WA: { 
    employeeRate: 0.0058 * 0.7263, // Employee share
    employerRate: 0.0058 * 0.2737, // Employer share
    wageBase: 168600,
    name: 'Washington Paid Family and Medical Leave'
  }
};

// ============================================================================
// Local Tax Jurisdictions (Major Cities)
// ============================================================================

export const LOCAL_TAX_JURISDICTIONS = {
  // New York City
  NYC: {
    state: 'NY',
    name: 'New York City',
    type: 'city',
    brackets: [
      { min: 0, max: 12000, rate: 0.03078 },
      { min: 12000, max: 25000, rate: 0.03762 },
      { min: 25000, max: 50000, rate: 0.03819 },
      { min: 50000, max: Infinity, rate: 0.03876 }
    ]
  },
  // Yonkers
  YONKERS: {
    state: 'NY',
    name: 'Yonkers',
    type: 'city',
    residentRate: 0.16395, // Percentage of state tax
    nonResidentRate: 0.005
  },
  // Philadelphia
  PHL: {
    state: 'PA',
    name: 'Philadelphia',
    type: 'city',
    residentRate: 0.038, // 3.8%
    nonResidentRate: 0.034481 // 3.4481%
  },
  // Pittsburgh
  PIT: {
    state: 'PA',
    name: 'Pittsburgh',
    type: 'city',
    rate: 0.03 // 3% for residents
  },
  // Detroit
  DET: {
    state: 'MI',
    name: 'Detroit',
    type: 'city',
    residentRate: 0.024,
    nonResidentRate: 0.012
  },
  // Cleveland
  CLE: {
    state: 'OH',
    name: 'Cleveland',
    type: 'city',
    rate: 0.024
  },
  // Columbus
  CMH: {
    state: 'OH',
    name: 'Columbus',
    type: 'city',
    rate: 0.025
  },
  // Cincinnati
  CVG: {
    state: 'OH',
    name: 'Cincinnati',
    type: 'city',
    rate: 0.019
  },
  // Baltimore
  BAL: {
    state: 'MD',
    name: 'Baltimore City',
    type: 'city',
    rate: 0.032
  },
  // St. Louis
  STL: {
    state: 'MO',
    name: 'St. Louis',
    type: 'city',
    residentRate: 0.01,
    nonResidentRate: 0.01
  },
  // Kansas City
  MCI: {
    state: 'MO',
    name: 'Kansas City',
    type: 'city',
    residentRate: 0.01,
    nonResidentRate: 0.005
  },
  // Denver (OPT)
  DEN: {
    state: 'CO',
    name: 'Denver',
    type: 'city',
    flatTax: 5.75 // Monthly occupational privilege tax
  },
  // Newark
  EWR: {
    state: 'NJ',
    name: 'Newark',
    type: 'city',
    rate: 0.01
  }
};

// ============================================================================
// 401(k) and Retirement Plan Limits (2024)
// ============================================================================

export const RETIREMENT_LIMITS_2024 = {
  '401k': {
    employeeElective: 23000,
    catchUp: 7500, // Age 50+
    totalAnnual: 69000, // Including employer contributions
    catchUpAge: 50
  },
  '403b': {
    employeeElective: 23000,
    catchUp: 7500,
    totalAnnual: 69000,
    catchUpAge: 50,
    fifteenYearCatchUp: 3000 // Additional for 15+ years of service
  },
  '457': {
    employeeElective: 23000,
    catchUp: 7500,
    catchUpAge: 50,
    specialCatchUp: 46000 // Last 3 years before retirement age
  },
  simpleIRA: {
    employeeElective: 16000,
    catchUp: 3500,
    catchUpAge: 50
  },
  ira: {
    contribution: 7000,
    catchUp: 1000,
    catchUpAge: 50
  },
  sep: {
    maxContribution: 69000,
    percentageLimit: 0.25 // 25% of compensation
  }
};

// ============================================================================
// HSA and FSA Limits (2024)
// ============================================================================

export const HEALTH_ACCOUNT_LIMITS_2024 = {
  hsa: {
    selfOnly: 4150,
    family: 8300,
    catchUp: 1000, // Age 55+
    catchUpAge: 55
  },
  fsa: {
    healthCare: 3200,
    carryover: 640, // Max carryover to next year
    dependentCare: 5000, // Single or married filing jointly
    dependentCareMarriedSeparate: 2500
  },
  commuter: {
    transit: 315, // Per month
    parking: 315 // Per month
  }
};

// ============================================================================
// Minimum Wage by State (as of 2024)
// ============================================================================

export const MINIMUM_WAGE = {
  federal: 7.25,
  AL: 7.25, // Federal
  AK: 11.73,
  AZ: 14.35,
  AR: 11.00,
  CA: 16.00,
  CO: 14.42,
  CT: 15.69,
  DE: 13.25,
  DC: 17.00,
  FL: 13.00,
  GA: 7.25,
  HI: 14.00,
  ID: 7.25,
  IL: 14.00,
  IN: 7.25,
  IA: 7.25,
  KS: 7.25,
  KY: 7.25,
  LA: 7.25,
  ME: 14.15,
  MD: 15.00,
  MA: 15.00,
  MI: 10.33,
  MN: 10.85,
  MS: 7.25,
  MO: 12.30,
  MT: 10.30,
  NE: 12.00,
  NV: 12.00,
  NH: 7.25,
  NJ: 15.13,
  NM: 12.00,
  NY: 15.00, // Varies by region
  NC: 7.25,
  ND: 7.25,
  OH: 10.45,
  OK: 7.25,
  OR: 14.70,
  PA: 7.25,
  RI: 14.00,
  SC: 7.25,
  SD: 11.20,
  TN: 7.25,
  TX: 7.25,
  UT: 7.25,
  VT: 13.67,
  VA: 12.00,
  WA: 16.28,
  WV: 8.75,
  WI: 7.25,
  WY: 7.25
};

// ============================================================================
// Tax Filing Deadlines
// ============================================================================

export const TAX_DEADLINES = {
  // Federal
  federal: {
    w2Distribution: { month: 1, day: 31, description: 'W-2 to employees' },
    w2Filing: { month: 1, day: 31, description: 'W-2/W-3 to SSA' },
    q1941: { month: 4, day: 30, description: 'Q1 Form 941' },
    q2941: { month: 7, day: 31, description: 'Q2 Form 941' },
    q3941: { month: 10, day: 31, description: 'Q3 Form 941' },
    q4941: { month: 1, day: 31, description: 'Q4 Form 941' },
    form940: { month: 1, day: 31, description: 'Form 940 Annual FUTA' },
    form944: { month: 1, day: 31, description: 'Form 944 (if eligible)' }
  },
  // Deposit schedules
  deposits: {
    monthly: {
      due: 15, // 15th of following month
      threshold: 50000 // If liability < $50,000 in lookback period
    },
    semiweekly: {
      wednesdayPayday: 'following Wednesday',
      thursdayPayday: 'following Friday',
      threshold: 50000 // If liability >= $50,000
    },
    nextDay: {
      threshold: 100000 // If accumulate $100,000+ in one day
    }
  }
};

// ============================================================================
// Form Types
// ============================================================================

export const TAX_FORMS = {
  employee: {
    w4: { name: 'Form W-4', description: 'Employee Withholding Certificate' },
    i9: { name: 'Form I-9', description: 'Employment Eligibility Verification' },
    w2: { name: 'Form W-2', description: 'Wage and Tax Statement' },
    w2c: { name: 'Form W-2c', description: 'Corrected Wage and Tax Statement' }
  },
  employer: {
    w3: { name: 'Form W-3', description: 'Transmittal of Wage and Tax Statements' },
    w3c: { name: 'Form W-3c', description: 'Transmittal of Corrected Wage and Tax Statements' },
    '940': { name: 'Form 940', description: 'Employer\'s Annual Federal Unemployment (FUTA) Tax Return' },
    '941': { name: 'Form 941', description: 'Employer\'s Quarterly Federal Tax Return' },
    '941x': { name: 'Form 941-X', description: 'Adjusted Employer\'s Quarterly Federal Tax Return' },
    '944': { name: 'Form 944', description: 'Employer\'s Annual Federal Tax Return' },
    '1099nec': { name: 'Form 1099-NEC', description: 'Nonemployee Compensation' },
    '1099misc': { name: 'Form 1099-MISC', description: 'Miscellaneous Income' }
  },
  contractor: {
    w9: { name: 'Form W-9', description: 'Request for Taxpayer Identification Number' },
    '1099nec': { name: 'Form 1099-NEC', description: 'Nonemployee Compensation' }
  }
};

// ============================================================================
// Garnishment Limits
// ============================================================================

export const GARNISHMENT_LIMITS = {
  // Consumer Credit Protection Act (CCPA) limits
  consumerDebt: {
    maxPercent: 0.25, // 25% of disposable earnings
    minExempt: 30, // 30x federal minimum wage per week protected
    description: 'Standard creditor garnishment'
  },
  childSupport: {
    maxSingleNoArrears: 0.50, // 50%
    maxMarriedNoArrears: 0.55, // 55%
    maxSingleWithArrears: 0.60, // 60% (12+ weeks behind)
    maxMarriedWithArrears: 0.65, // 65%
    description: 'Child support and alimony'
  },
  studentLoan: {
    maxPercent: 0.15, // 15% of disposable earnings
    minExempt: 30, // 30x minimum wage protected
    description: 'Federal student loans'
  },
  taxLevy: {
    // IRS Publication 1494 tables apply
    maxPercent: 1.0, // Can take everything above exempt amount
    description: 'Federal tax levy (see Pub 1494)'
  }
};

// ============================================================================
// ACH File Format Reference
// ============================================================================

export const ACH_FORMAT = {
  fileHeader: {
    recordType: '1',
    priorityCode: '01',
    immediateOrigin: 'Company Tax ID',
    immediateDestination: 'Bank Routing Number',
    fileCreationDate: 'YYMMDD',
    fileCreationTime: 'HHMM',
    fileIdModifier: 'A-Z or 0-9',
    recordSize: '094',
    blockingFactor: '10',
    formatCode: '1'
  },
  batchHeader: {
    recordType: '5',
    serviceClassCode: '200/220/225', // Mixed/Credits/Debits
    companyName: '16 chars',
    companyDiscretionaryData: '20 chars',
    companyIdentification: 'Tax ID',
    standardEntryClass: 'PPD/CCD',
    companyEntryDescription: '10 chars',
    effectiveEntryDate: 'YYMMDD'
  },
  entryDetail: {
    recordType: '6',
    transactionCode: '22/32/27/37', // Checking credit/debit, Savings credit/debit
    rdfiId: '8-digit routing',
    checkDigit: '9th digit of routing',
    dfiAccountNumber: 'Account number',
    amount: '10-digit amount',
    individualId: 'Employee ID',
    individualName: '22 chars'
  }
};

// ============================================================================
// Pay Statement Requirements by State
// ============================================================================

export const PAYSTUB_REQUIREMENTS = {
  CA: {
    required: true,
    mustInclude: ['gross', 'net', 'deductions', 'hours', 'rates', 'payPeriod', 'employeeInfo', 'employerInfo', 'ytd'],
    electronic: true,
    paperRequired: false
  },
  NY: {
    required: true,
    mustInclude: ['gross', 'net', 'deductions', 'hours', 'rates', 'payPeriod', 'allowances'],
    electronic: true,
    paperRequired: false
  },
  TX: {
    required: true,
    mustInclude: ['gross', 'deductions', 'net'],
    electronic: true,
    paperRequired: false
  },
  FL: {
    required: false, // No state requirement
    recommended: ['gross', 'net', 'deductions']
  }
  // Add more states as needed
};

// ============================================================================
// Common Payroll Cycles
// ============================================================================

export const PAYROLL_CYCLES = {
  weekly: {
    code: 'W',
    periodsPerYear: 52,
    description: 'Every week',
    commonPayDay: 'Friday',
    processingLead: 3 // Days before pay date to process
  },
  biweekly: {
    code: 'B',
    periodsPerYear: 26,
    description: 'Every two weeks',
    commonPayDay: 'Friday',
    processingLead: 5
  },
  semimonthly: {
    code: 'S',
    periodsPerYear: 24,
    description: 'Twice per month (1st & 15th or 15th & last)',
    commonPayDays: [1, 15],
    processingLead: 5
  },
  monthly: {
    code: 'M',
    periodsPerYear: 12,
    description: 'Once per month',
    commonPayDay: 'Last day of month',
    processingLead: 7
  }
};

// ============================================================================
// Bank Holidays (Federal Reserve)
// ============================================================================

export const FEDERAL_HOLIDAYS_2024 = [
  { date: '2024-01-01', name: 'New Year\'s Day' },
  { date: '2024-01-15', name: 'Martin Luther King Jr. Day' },
  { date: '2024-02-19', name: 'Presidents\' Day' },
  { date: '2024-05-27', name: 'Memorial Day' },
  { date: '2024-06-19', name: 'Juneteenth' },
  { date: '2024-07-04', name: 'Independence Day' },
  { date: '2024-09-02', name: 'Labor Day' },
  { date: '2024-10-14', name: 'Columbus Day' },
  { date: '2024-11-11', name: 'Veterans Day' },
  { date: '2024-11-28', name: 'Thanksgiving Day' },
  { date: '2024-12-25', name: 'Christmas Day' }
];

export const FEDERAL_HOLIDAYS_2025 = [
  { date: '2025-01-01', name: 'New Year\'s Day' },
  { date: '2025-01-20', name: 'Martin Luther King Jr. Day' },
  { date: '2025-02-17', name: 'Presidents\' Day' },
  { date: '2025-05-26', name: 'Memorial Day' },
  { date: '2025-06-19', name: 'Juneteenth' },
  { date: '2025-07-04', name: 'Independence Day' },
  { date: '2025-09-01', name: 'Labor Day' },
  { date: '2025-10-13', name: 'Columbus Day' },
  { date: '2025-11-11', name: 'Veterans Day' },
  { date: '2025-11-27', name: 'Thanksgiving Day' },
  { date: '2025-12-25', name: 'Christmas Day' }
];

// ============================================================================
// State Names (Full names for all US states and territories)
// ============================================================================

export const STATE_NAMES = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
  FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois',
  IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
  ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
  MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
  NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
  NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon',
  PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota',
  TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia',
  WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
  PR: 'Puerto Rico', VI: 'Virgin Islands', GU: 'Guam', AS: 'American Samoa',
  MP: 'Northern Mariana Islands'
};

// ============================================================================
// Export All
// ============================================================================

export default {
  FEDERAL_WITHHOLDING_TABLES,
  SUI_RATES,
  SDI_DATA,
  PFML_DATA,
  LOCAL_TAX_JURISDICTIONS,
  RETIREMENT_LIMITS_2024,
  HEALTH_ACCOUNT_LIMITS_2024,
  MINIMUM_WAGE,
  TAX_DEADLINES,
  TAX_FORMS,
  GARNISHMENT_LIMITS,
  ACH_FORMAT,
  PAYSTUB_REQUIREMENTS,
  PAYROLL_CYCLES,
  FEDERAL_HOLIDAYS_2024,
  FEDERAL_HOLIDAYS_2025,
  STATE_NAMES
};
